import { PAGE_TYPES } from './constants';

/**
 * Detecta el tipo de página según la URL pathname
 * @param {string} pathname - window.location.pathname
 * @returns {string} - Tipo de página según PAGE_TYPES
 */
export const detectPageType = (pathname) => {
  // Normalizar pathname (remover trailing slash excepto para home)
  const normalizedPath = pathname === '/' ? pathname : pathname.replace(/\/$/, '');

  // Mapping según especificaciones de Jakala
  if (normalizedPath === '/') return PAGE_TYPES.HOME;

  if (normalizedPath.startsWith('/compra-en-linea') ||
    normalizedPath.startsWith('/marketplace')) {
    return PAGE_TYPES.BUY_ONLINE;
  }

  if (normalizedPath.startsWith('/contactanos') ||
    normalizedPath.startsWith('/solicita-ayuda')) {
    return PAGE_TYPES.CONTACT;
  }

  if (normalizedPath.startsWith('/distribuidores')) {
    return PAGE_TYPES.STORE_LOCATOR;
  }

  if (normalizedPath.startsWith('/tu-calentador-ideal')) {
    return PAGE_TYPES.CONFIGURATOR;
  }

  if (normalizedPath.startsWith('/comparador')) {
    return PAGE_TYPES.COMPARATOR;
  }

  if (normalizedPath.startsWith('/nosotros') ||
    normalizedPath.startsWith('/servicio-calorex')) {
    return PAGE_TYPES.WHO_WE_ARE;
  }

  if (normalizedPath.startsWith('/promociones')) {
    return PAGE_TYPES.PROMOTIONS;
  }

  if (normalizedPath.startsWith('/newsletter')) {
    return PAGE_TYPES.NEWSLETTER;
  }

  if (normalizedPath.startsWith('/calentadores/')) {
    return PAGE_TYPES.PRODUCT;
  }

  return PAGE_TYPES.OTHER;
};
